import {defineStore} from 'pinia';
import redirect_error_page from "@/util/redirect_error_page"
import { useVersionStore } from './version_store';
import apiRequest from '@/util/api-request';
import { AxiosRequestConfig } from 'axios';

interface IClassroom{
    id:number;
    name:string;
}
interface IClassroomList {
    modal_display_time: string | null;
    classroom_list: Array<IClassroom>;
}

export const useNextGradeStore = defineStore('nextGradeStore', {
    // state
    state: ():IClassroomList => {
        return {
            modal_display_time: null,
            classroom_list: []
        }
    },
    // actioins
    actions: {
        async fetchNextGradeClassroomList(){
            // fetch classroom list
            const versionStore = useVersionStore()
            try {
                const config: AxiosRequestConfig = {
                    method: 'get',
                    url: '/student/api/next_grade/student_classroom_list',
                };
                const result = await apiRequest(config);
                this.modal_display_time = result.data.modal_display_time
                this.classroom_list = result.data.classroom_list
                versionStore.saveAppVersion(result.headers["x-app-version"])
            }
            catch (e) {
                redirect_error_page(e)
            }
        },
        async saveModalDisplayTime(){
            const versionStore = useVersionStore()
            try {
                const config: AxiosRequestConfig = {
                    method: 'post',
                    url: '/student/api/next_grade/modal_display_time',
                };
                const result = await apiRequest(config);
                versionStore.saveAppVersion(result.headers["x-app-version"])
            }
            catch (e) {
                redirect_error_page(e)
            }
        },
        async saveClassroomStudent(selected_classroom: string, attendance_number: string){
            const versionStore = useVersionStore()
            try {
                const config: AxiosRequestConfig = {
                    method: 'post',
                    url: '/student/api/next_grade/save_classroom_student',
                    data: {
                        selected_classroom: selected_classroom,
                        attendance_number: attendance_number
                    }
                };
                const result = await apiRequest(config);
                // reset state after save classroom student
                this.modal_display_time = null
                this.classroom_list = []
                versionStore.saveAppVersion(result.headers["x-app-version"])
                return result.data
            }
            catch (e) {
                redirect_error_page(e)
            }
        }
    }
})